'use client';

import Link from 'next/link';
import {CompanyLogo} from 'iq-interview_guides/components/company_logo';
import {DotSeparator} from 'common/components/dot_separator';
import {timeSince} from 'common/utils';
import {trackRightRailAllCompaniesClicked, trackRightRailCompanyClicked} from 'iq-companies/tracking';
import type {CompanyGuideListItem} from 'iq-companies/types';
import {ContributionModule} from './contribution_module';

const RAIL_SIZE = 5;

// One browse surface — no separate top strip (see plan § Phase 0, sketch deviation).
// Sticky alongside the feed on desktop; stacks below it on mobile. companies comes
// from the enhanced GET /v1/company-interview-guides (plan § 1b) — CIG-scoped.
export function RightRail({companies}: {companies: CompanyGuideListItem[]}) {
  const top = [...companies].sort((a, b) => b.experience_count - a.experience_count).slice(0, RAIL_SIZE);

  return (
    <aside className='flex w-80 shrink-0 flex-col gap-6 max-[960px]:w-full max-[960px]:static min-[961px]:sticky min-[961px]:top-4'>
      <div className='rounded-xl border border-gray-200 bg-white p-6'>
        <h2 className='mb-3 text-lg font-bold text-gray-900'>Browse companies</h2>
        <div className='flex flex-col divide-y divide-gray-100'>
          {top.map((c) => (
            <Link
              key={c.company_slug}
              href={`/interview-guides/${c.slug}`}
              onClick={() => void trackRightRailCompanyClicked(c.company_slug)}
              className='flex items-center gap-3 py-3 transition-opacity first:pt-0 last:pb-0 hover:opacity-80'>
              <CompanyLogo
                companyWebsite={c.company_website}
                companyName={c.company_name}
                size={32}
                className='rounded object-contain'
              />
              <span className='min-w-0'>
                <span className='block text-sm font-medium text-gray-900'>{c.company_name}</span>
                <span className='flex flex-wrap items-center gap-1 text-xs text-gray-500'>
                  <span>{c.experience_count} experiences</span>
                  <DotSeparator className='text-gray-300' />
                  <span>updated {timeSince(c.updated_at)}</span>
                </span>
              </span>
            </Link>
          ))}
        </div>
        <Link
          href='/companies/all'
          onClick={() => void trackRightRailAllCompaniesClicked()}
          className='mt-4 block border-t border-gray-100 pt-4 text-sm font-semibold text-iq-orange hover:opacity-80'>
          All companies →
        </Link>
      </div>
      <ContributionModule />
    </aside>
  );
}
